<template>
    <!-- 对话框 -->
    <el-dialog title="集团资金流水" :visible.sync="show" :before-close="closeDialog" width="80%">
        <div style="width: 95%; margin: 0 auto">
            <div>
                <div class="handle-box-search">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span>操作类型:</span>
                                <el-select
                                    multiple
                                    style="width: 340px"
                                    v-model="groupOperation"
                                    placeholder="请选择"
                                    clearable
                                    @change="operationChange"
                                    @keyup.enter.native="waterSearch"
                                >
                                    <el-option v-for="item in operationGroup" :key="item.val" :label="item.alias" :value="item.val">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <span>集团名称：</span>
                                <el-select
                                    filterable
                                    remote
                                    :filter-method="filterMethod"
                                    v-model="search_data_children.group_wallet_code"
                                    placeholder="请选择集团"
                                    @visible-change="groupVisibleChange"
                                    @change="groupNameChange"
                                    clearable
                                    @keyup.enter.native="waterSearch"
                                    style="position: relative; width: 200px"
                                >
                                    <el-option
                                        v-for="item in options_group_info"
                                        :key="item.group_wallet_code"
                                        :label="item.group_name"
                                        :value="item.group_wallet_code"
                                    >
                                    </el-option>

                                    <!-- 分页组件 -->
                                    <el-pagination
                                        @current-change="handleCurrentChangeGroup"
                                        layout="prev, pager, next"
                                        :total="result_data_group.count"
                                        :page-size="search_data_group.limit"
                                    ></el-pagination>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row class="head-search">
                            <el-col :span="24">
                                <span> 操作时间:</span>
                                <el-date-picker
                                    v-model="search_time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="timeChange"
                                    style="margin-bottom: 20px; margin-right: 20px; width: 340px"
                                >
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button @click="waterSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                    <!-- <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
          <el-button icon="el-icon-setting" @click="toExport" v-else
            >导出</el-button
          > -->
                </div>
            </div>

            <div class="driver_water">
                <div><span>查询时间段内增加余额：</span>{{ all.add }}</div>

                <div><span>查询时间段内减少余额：</span>{{ all.sub }}</div>
            </div>

            <!-- 表格 -->
            <el-table :data="tableData" max-height="500" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <div>
                                <el-form-item label="对应表:">
                                    <span>{{ props.row.table_name }}</span>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="相关编号:">
                                    <span>{{ props.row.record_code }}</span>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item label="备注:">
                                    <span>{{ props.row.remark }}</span>
                                </el-form-item>
                            </div>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="group_wallet.group_name" label="集团名称"> </el-table-column>
                <!-- <el-table-column prop="consumer.phone" label="所属城市"> </el-table-column> -->

                <el-table-column prop="operation.alias" label="账户操作"> </el-table-column>

                <el-table-column prop="amount" label="操作金额"> </el-table-column>

                <el-table-column prop="description" label="描述"> </el-table-column>

                <!-- <el-table-column prop="surplus" label="结算后余额"> </el-table-column> -->

                <el-table-column prop="time.YmdHis" label="操作时间"> </el-table-column>

                <el-table-column prop="mode.alias" label="账本模式"> </el-table-column>

                <el-table-column prop="remark" label="备注"> </el-table-column>
                <!-- <el-table-column prop="operator_name" label="操作人"> </el-table-column> -->

            </el-table>

            <!-- element ui 原生分页组件 -->
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data_children.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="search_data_children.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="result_data.count"
                >
                </el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },

    components: {},
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.getGroupInfo();
            _this.waterSearch();
        }
    },
    data() {
        return {
            options_group_info: [], //存放集团编码和集团名称
            operationGroup: [], //存放操作类型从接口取的数组值
            groupOperation: [], //操作类型绑定值，可多选

            search_phone: '',
            result_data: [],
            result_data_group: '',
            all: {
                add: '',
                sub: ''
            },

            show: false,

            search_time: '',

            tableData: [],

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                operation: '',
                group_wallet_code_array: '',
                group_wallet_code: '',
                // city_code: "",
                // city_tag: "",
                fixed_array: ''
            },
            //翻页数据
            search_data_group: {
                page: 1,
                limit: 5,
                group_name: '',
                activity_status: ''
            },

            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 刷新按钮
        refresh() {
            _this.options_group_info = [];
            _this.tableData = [];
            _this.search_time = '';
            _this.all = {};
            _this.search_data_children = {
                page: 1,
                limit: 10,
                operation: '',
                group_wallet_code_array: '',
                group_wallet_code: '',
                // city_code: "",
                // city_tag: "",
                fixed_array: ''
            };
            _this.search_data_group = {
                page: 1,
                limit: 5,
                group_name: '',
                activity_status: ''
                // city_code: "",
                // city_tag: "",
            };
            _this.getGroupInfo();
            _this.waterSearch();
        },
        operationChange() {
            _this.search_data_children.operation = JSON.stringify(_this.groupOperation);
            console.log(_this.search_data_children.operation, '_this.search_data_children.operation');
        },
        groupNameChange() {
            console.log(_this.search_data_children.group_wallet_code, 'search_data_children.group_wallet_code');
        },
        filterMethod(val) {
            console.log(val, 'filterMethod-val');
            // console.log(_this.$refs['selectAdmin'].$children[0].getInput().value);

            // return

            _this.search_data_group.group_name = val;

            _this.search_data_group.page = 1;

            _this.groupVisibleChange(true);
        },
        groupVisibleChange(val) {
            console.log(val, 'groupVisibleChange-val');
            if (!val) {
                _this.search_data_group.group_name = '';
            }
            _this.getGroupInfo();
        },

        //获取集团列表拿到集团编码值和集团名
        getGroupInfo() {
            _this
                .$post('/group/groupWalletLists', _this.search_data_group, _this.search_rules_children)
                .then((res) => {

                 _this.options_group_info=res.data;


                    _this.result_data_group = res;

                    console.log(_this.options_group_info, '_this.options_group_info');
                })
                .catch((err) => {});
        },

        groupChange(val) {
            console.log(val);
            _this.search_data_children.group_wallet_code = val;
        },

        waterSearch() {
            _this.search_data_children.page = 1;

            _this.groupRecordLists();
        },

        timeChange(val) {
            console.log(val);
            if (val != null) {
                _this.search_data_children.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data_children.fixed_array = '';
            }
        },

        // 获取账单信息
        groupRecordLists() {
            console.log(_this.search_data_children.page,'_this.search_data_children.page');
            _this
                .$post('/group/groupRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data.result;
                    _this.result_data = res.data;

                    _this.operationGroup = res.data.result[0].operation.select_array;
                    console.log(_this.operationGroup, '_this.operation');

                    if (res.data.length != 0) {
                        _this.all = res.data.all;
                    }
                })
                .catch((err) => {});
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data_children.limit = val;
            console.log(_this.search_data_children.limit, '_this.search_data_children.limit');

            //初始化列表
            _this.groupRecordLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.groupRecordLists();
        },
        //页码变化
        handleCurrentChangeGroup(val) {
            _this.search_data_group.page = val;

            //初始化列表
            _this.getGroupInfo();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.options_group_info = [];
            _this.tableData = [];
            _this.search_time = '';
            _this.all = {};
            _this.search_data_children = {
                page: 1,
                limit: 10,
                operation: '',
                group_wallet_code_array: '',
                group_wallet_code: '',
                // city_code: "",
                // city_tag: "",
                fixed_array: ''
            };
            _this.search_data_group = {
                page: 1,
                limit: 5,
                group_name: '',
                activity_status: ''
                // city_code: "",
                // city_tag: "",
            };
        }
    }
};
</script>

<style scoped>
.search_style {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.driver_water {
    color: #606266;
    margin-bottom: 20px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.capital-title {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}
.money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}
.money {
    margin-left: 5px;
}
.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
    border: 0 !important;
}
.el-date-range-picker__time-header {
    display: block;
}
</style>




